import React, {ChangeEvent} from 'react';
import {ReactComponent as BasketIcon} from '../../../../../../../assets/main/profile-box/basket.svg';
import {ReactComponent as KeyIcon} from '../../../../../../../assets/main/profile-box/key.svg';

import {ReactComponent as PhotoIcon} from '../../../../../../../assets/main/profile-box/photo.svg';

import {ReactComponent as EditIcon} from '../../../../../../../assets/main/groups/main-top/edit.svg';
import {useAppDispatch, useAppSelector} from "../../../../../../../common/hook";
import {setChangePasswordAC, setEditProfileAC} from "../../../../../../../app/popups-reducer";
import {getProfileData} from "../../../../../../../entities/Profile/model/selectors/getProfileData/getProfileData";
import {deleteAvatar} from "../../../../../../../features/model/service/avatar/fetchDeleteAvatar";
import {uploadAvatar} from "../../../../../../../features/model/service/avatar/fetchAddAvatar";
import {setAvatar} from "../../../../../../../features/model/slice/avatarSlice";

export const BoxStudent = () => {
    const data = useAppSelector(getProfileData)
    const isEditProfile = useAppSelector((state) => state.popups.isEditProfile);
    const isChangePassword = useAppSelector((state) => state.popups.isChangePassword);
    const dispatch = useAppDispatch()

    const deleteAvatarHandler = () => {
        dispatch(deleteAvatar());
    }

    const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) {
            return;
        }
        try {
            const resultAction = await dispatch(uploadAvatar(file));
            if (uploadAvatar.fulfilled.match(resultAction)) {
                dispatch(setAvatar(resultAction.payload));
            }
        } catch (error) {
            console.error('Error uploading avatar:', error);
        }
    };


    const onClickEditHandler = () => {
        dispatch(setEditProfileAC(!isEditProfile))
    }

    const onClickPasswordHandler = () => {
        dispatch(setChangePasswordAC(!isChangePassword))
    }


    return (
        <div className="person-data-box">
            <div className="person-data-col">
                <div className="person-avatar-box">
                    <div className="person-avatar avatar">
                        <label htmlFor="avatar-input" className="avatar-input-label">
                            <input
                                type="file"
                                id="avatar-input"
                                accept="image/*"
                                onChange={handleFileChange}
                                style={{display: 'none'}}
                            />
                            {data?.avatar &&
                                <img src={data.avatar} alt=""/>
                            }
                            {data?.hasAvatar ?
                                <button className="action-btn" onClick={deleteAvatarHandler}>
                                    <BasketIcon/>
                                </button>
                                : <span className="action-btn"><PhotoIcon/></span>}
                        </label>
                    </div>
                </div>
                <div className="person-data">
                    <p className="h3 person-name">{data?.fullName}</p>
                    {data?.company ?
                        <p className="sub-text">{data?.roleName} / {data?.company}</p>
                        :
                        <p className="sub-text">{data?.roleName}</p>
                    }
                </div>
            </div>
            <div className="person-controls-col">
                <p className="p-icon control-btn pointer-elem" onClick={onClickEditHandler}>
                    Редактировать профиль{" "}
                    <span className="icon">
                                <EditIcon/>
                            </span>
                </p>
                <p className="p-icon control-btn pointer-elem" onClick={onClickPasswordHandler}>
                    Сменить пароль
                    <span className="icon">
                        <KeyIcon/>
                    </span>
                </p>
            </div>
        </div>
    );
};

